<template>
  <div style="user-select: none;">
    <div class="price-slider">
      <vue-slider
        v-model="actPriceRange"
        v-bind="sliderOptions"
        :tooltip-formatter="formatter"
      />
      <div class="price-range-text">
        <!-- change left to offset of first dot -->
        <em>{{ priceString }}</em>
      </div>
    </div>
  </div>
</template>

<script>

import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min';
import 'vue-slider-component/dist-css/vue-slider-component.css';
import 'vue-slider-component/theme/default.css';
import { mapMutations } from 'vuex';
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import getNumberFormat from 'mixins/composition/NumberFormat';
import GtmTools from 'mixins/GtmTools';
import config from 'config/appConfig';
// import { gtmFilterMapping } from 'config/trackingParams';

export default {
  name: 'SearchpriceRanges',
  components: { VueSlider },
  mixins: [GtmTools],
  setup(_, ctx) {
    const { formatNumber, formatCurrency } = getNumberFormat(ctx);
    return { formatNumber, searchRedirect, formatCurrency };
  },
  data() {
    return {
      sliderOptions: {
        min: 0,
        max: config.defaults.searchPriceMax,
        interval: config.defaults.searchPriceInterval,
        lazy: true,
        tooltip: 'always',
      },
      formatter: (v) => `${(v >= config.defaults.searchPriceMax) ? '> ' : ''}${(`${this.formatCurrency(v, undefined, undefined, { minimumFractionDigits: 0 })}`)}`,
    };
  },
  computed: {
    actPriceRange: {
      get() {
        return [
          this.$store.getters.getSearchFilter('priceMin') || 0,
          this.$store.getters.getSearchFilter('priceMax') || config.defaults.searchPriceMax,
        ];
      },
      set(newPriceRanges) {
        const [min, max] = newPriceRanges;
        if (min && max) {
          this.dataLayerPush({ event: 'asnnutzung', asnfilter: `priceRange_${min}-${max}` });
        } else if (min) { this.dataLayerPush({ event: 'asnnutzung', asnfilter: `priceMin_${min}` }); } else if (max) { this.dataLayerPush({ event: 'asnnutzung', asnfilter: `priceMax_${max}` }); }

        // this.search({ router: this.$router, filters: { priceMin: min, priceMax: max } });
        searchRedirect({ router: this.$router, filters: { priceMin: min, priceMax: max } });
      },
    },
    ranges() {
      return this.$store.getters.getAggregation('priceRanges');
    },
    maxRange() {
      const arr = Object.values(this.ranges);
      return Math.max(...arr);
    },
    priceString() {
      const priceMin = this.$store.getters.getSearchFilter('priceMin');
      let priceMax = this.$store.getters.getSearchFilter('priceMax');
      if (priceMax === config.defaults.searchPriceMax) {
        priceMax = 0;
      }
      if (priceMax > 0 && priceMin > 0) {
        return `${this.formatCurrency(priceMin, undefined, undefined, { minimumFractionDigits: 0 })} - ${this.formatCurrency(priceMax, undefined, undefined, { minimumFractionDigits: 0 })} `;
      }
      if (priceMin > 0) {
        return this.$t('filter:select.tabs:price_interval', {
          postProcess: 'interval',
          count: 2, // only for post process decision
          price: this.formatCurrency(priceMin, undefined, undefined, { minimumFractionDigits: 0 }), // for string output
        });
      }
      if (priceMax > 0) {
        return this.$t('filter:select.tabs:price_interval', {
          postProcess: 'interval',
          count: 1, // only for post process decision
          price: this.formatCurrency(priceMax, undefined, undefined, { minimumFractionDigits: 0 }), // for string output
        });
      }

      return this.$t('filter:select.tabs:price_interval', {
        postProcess: 'interval',
        count: 0, // only for post process decision
      });
    },
  },
  watch: {
    selectedPriceRange(priceRange) {
      searchRedirect({
        router: this.$router,
        filters: {
          priceMin: this.priceRanges[priceRange][0],
          priceMax: this.priceRanges[priceRange][1],
        },
      });
    },
  },
  methods: {
    ...mapMutations({ setSearchFilter: 'SET_SEARCHFILTER' }),
  },

};
</script>

<style lang="scss" scoped>

.price-categories {
  position: relative;
  border-left: 1px solid $color_ci_complement;
  display: none;

  .price-category {
    width: 33.333%;
    height: 10px;
    z-index: 0;
    margin: 3px 0 0 0;
    position: absolute;
    border-right: 1px solid $color_grey_100;

    em {
      margin: 0.5em 0 0;
      text-align: center;

      @include font_regular;
      @include font_size_s;

      color: $color_grey;
      display: block;
    }
  }

  .price-category-1 {
    left: 0;
  }

  .price-category-2 {
    left: 33.3333%;
  }

  .price-category-3 {
    left: 66.6%;
    width: 33.3%;
  }
}

.price-range {
  position: relative;
  margin: 0 3px 10px;

  @media #{$media_xs} {
    margin: 0 20px 10px;
  }
}

.price-range-text {
  margin: 0.5em auto 0;
  color: $color_ci_complement;
  text-align: center;

  em {
    @include font_bold;
  }
}

.vue-slider {
  height: 4px !important;
  padding: 15px !important;
  margin-top: 0; /* container height */
  margin: 1em 0;

  .popover-body & {
    margin: 1em 0.5em;
  }
}

.vue-slider-dot-tooltip-inner {
  border-color: $color_ci_complement !important;
  background: $color_ci_complement !important;
}

/deep/ .vue-slider-rail {
  background: none;
  height: 40px !important;
  margin: -25px 0 0 0;
  border-bottom: 4px solid $color_grey_100;

  @include radius(0);
}

/deep/ .vue-slider-process {
  background: none;
  height: 40px !important;
  margin: 0;
  border-bottom: 4px solid $color_ci_complement_400;

  @include radius(0);
}

/deep/ .vue-slider-dot-handle {
  border-radius: 0;
  height: 40px;
  background: none;
  margin: 0 0 0 -8px;
  padding: 0 15px;
  width: auto;
  -moz-box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  -webkit-box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);

  &::after {
    content: '';
    margin: 0 0 0 -2px;
    width: 4px;
    height: 16px;
    background: rgba($color_ci, 1);
    display: none;

    @include radius(3px);
    @include radius(20px);
  }

  &::before {
    content: '';
    background: var(--color_ci);
    width: 25px;
    height: 25px;
    position: absolute;
    top: 15px;
    left: -5px;

    @include radius(3px);
    @include radius(20px);
  }
}

/deep/ .vue-slider-dot-tooltip {
  top: 16px;
  margin: -6px 0 0;
  // visibility: visible !important;
}

/deep/ .vue-slider-dot-tooltip-inner {
  background: $color_ci_complement;

  &::after {
    border-top-color: $color_ci_complement;
  }
}

</style>
